import * as React from 'react';

import ContactForm from "../../../common/ContactForm/ContactForm";
import PageInfo from "../../../common/PageInfo/PageInfo";

import * as styles from './Contacts.module.scss';

class Contacts extends React.Component {
  render() {
    return (
      <section className={styles.root}>
        <div className={styles.backgroundImage}/>
        <div className={styles.containerWrapper}>
          <div className={styles.infoBlock}>
            <div className={styles.titleBlock}>
              <div className={styles.title}>Contacts</div>
              <div className={styles.divider}/>
            </div>
            <ContactForm/>
          </div>
          <PageInfo text='10 - contacts'/>
        </div>
      </section>
    )
  }
}

export default Contacts;